import Constants from '../../constants/Constants';
import { diContainer, serviceNames } from '../../diContainer/diContainer';
import Address from '../../domain/entities/Address';
import AddressRepository from '../../repositories/AddressRepository';
import ShippingRepository from '../../repositories/ShippingRepository';
import TransactionRepository from '../../repositories/TransactionRepository';

class UpsSetValidationsUseCase {
  private addressRepository: AddressRepository;

  private transactionRepository: TransactionRepository;

  private shippingRepository: ShippingRepository;

  private address: Address;

  constructor(address: Address) {
    this.address = address;
    this.addressRepository = diContainer.get(serviceNames.addressRepository);
    this.transactionRepository = diContainer.get(serviceNames.transactionRepository);
    this.shippingRepository = diContainer.get(serviceNames.shippingRepository);
  }

  public execute = async (): Promise<void> => {
    const suggestions = await this.addressRepository.getAddressSuggestions(this.address);
    if (suggestions && suggestions.length) {
      const upsAddress = suggestions[0];
      this.shippingRepository.setUpsAddress(this.address.attributes, upsAddress.attributes);
      throw new Error(Constants.UPS_VALIDATION);
    }
  };
}

export default UpsSetValidationsUseCase;
